import './Media.css';
import { useEffect, useContext, useRef } from 'react';
import { AudienceContext } from '../../../context/AudienceContext';
import { ChannelsContext } from '../../../context/ChannelsContext';
import { usePreference } from '../../../context/usePreference';
import { getUserPreferenceLocalStorage } from '../../../context/utils';
import { HandleAudienceTimeDoAudience } from '../../../utils/audienceUtils';
import { UserPreferenceContext } from "../../../context/UserPreferenceContext";
import { MediaTable } from './MediaTable';
import { MediaNetWorkMessage } from './MediaNetWorkMessage';
import { MediaErrorMessage } from './MediaErrorMessage';
import { NetworkAlertContext } from '../../../context/NetworkAlertContext';
import { DivMinuteEnum, SelectTypeGridEnum } from '../../../utils/enums';


function Media({ onSelectGrid, selectTypeGrid, DivMinute, DivChart }) {

  const { audienceMedia,
    audienceMediaFirstTable,
    doAudienceMedia,
    lastMinute,
    changeBaseMinuteMedia,
    resetQtdMinutosMedia,
    setAudience,
    setAudienceFirstTable,
    setAudienceMedia,
    setAudienceMediaFirstTable,
    setLastAudience
  } = useContext(AudienceContext);
  const { channels, doChannels } = useContext(ChannelsContext);
  const { lastThirtyAudiencePie,
    lastAudience } = useContext(AudienceContext);
  const {
    setHoraFinCalendar,
    setHoraIniCalendar
  } = useContext(UserPreferenceContext);
  const user = usePreference();
  const { showError, setShowError, infoError, showInfo, infoSpan } = useContext(NetworkAlertContext);
  const hasLoadedAtBottom = useRef(false);
  const bottomCooldown = useRef<NodeJS.Timeout | null>(null);
  const autoUpdateTimerRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (DivMinute === DivMinuteEnum.Minute || DivMinute === DivMinuteEnum.Media) {
      setAudienceMedia([]);
      setAudienceMediaFirstTable([]);
      setAudience([]);
      setAudienceFirstTable([]);
      setLastAudience([]);
    }
  }, [DivMinute]);
  useEffect(() => {
    if (DivMinute === DivMinuteEnum.Media) {
      resetQtdMinutosMedia();
      loadAudienceMedia()
      initilizeAudienceMediaTimer()
      doChannels()
    }
  }, [DivMinute]);

  // Cleanup timer quando componente é desmontado
  useEffect(() => {
    return () => {
      if (autoUpdateTimerRef.current) {
        clearInterval(autoUpdateTimerRef.current);
      }
    };
  }, []);


  function loadAudienceMedia() {
    const selectTypeGridLs = localStorage.getItem("selectTypeGrid") != null ? parseInt(localStorage.getItem("selectTypeGrid")!) : selectTypeGrid;
    if (selectTypeGridLs === SelectTypeGridEnum.None || DivMinute === DivMinuteEnum.Media) {
      doAudienceMedia().then(res => {
        HandleAudienceTimeDoAudience(user.userPreference, lastMinute, setHoraFinCalendar, setHoraIniCalendar, audienceMediaFirstTable, 'Media-useEffect');
      }).catch(err => {
      });
    }
  }
  function initilizeAudienceMediaTimer() {
    // Limpa timer anterior se existir
    if (autoUpdateTimerRef.current) {
      clearInterval(autoUpdateTimerRef.current);
      autoUpdateTimerRef.current = null;
    }

    if (user.userPreference?.ChangeAutoUpdate) {
      autoUpdateTimerRef.current = setInterval(TimerAutoUpdate, 30000);
    }
  }

  function TimerAutoUpdate() {
    const userStorage = getUserPreferenceLocalStorage();
    if (userStorage?.autoUpdate) {
      doAudienceMedia().then(res => {
        HandleAudienceTimeDoAudience(user.userPreference, lastMinute, setHoraFinCalendar, setHoraIniCalendar, audienceMediaFirstTable, 'TimerAutoUpdate');
      }).catch(err => {
      });
    }
  }

  const handleScroll = (e) => {
    let chartLine = document.querySelector("#MediaGraphic #chartLine");
    let tableGraphicPie = document.querySelector("#tableGraphicPie");
    let divMediaCompRight = document.querySelector("#divMediaCompRight");
    if (chartLine !== null)
      chartLine.scrollLeft = e.target.scrollLeft;
    if (tableGraphicPie !== null)
      tableGraphicPie.scrollLeft = e.target.scrollLeft;
    if (divMediaCompRight !== null)
      divMediaCompRight.scrollLeft = e.target.scrollLeft;

    const bottom = Math.abs(e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight)) <= 0.9;
    if (bottom && !hasLoadedAtBottom.current && !bottomCooldown.current) {
      changeBaseMinuteMedia(31);
      loadAudienceMedia();
      bottomCooldown.current = setTimeout(() => {
        bottomCooldown.current = null;
      }, 1000);
    } else if (!bottom) {
      hasLoadedAtBottom.current = false;
    }
  }
  function onSelectGridMinute() {
    onSelectGrid(true);
  }

  return (
    <div id="divMediaComponent" data-testid="divMediaComponent" style={{ width: '100%', position: "absolute" }}>
      {showError ? <MediaErrorMessage setShowError={setShowError} infoError={infoError} /> : ''}
      <MediaTable
        audienceMedia={audienceMedia}
        audienceMediaFirstTable={audienceMediaFirstTable}
        heading={channels}
        handleScroll={handleScroll}
        onSelectGridMinute={onSelectGridMinute}
        selectTypeGrid={selectTypeGrid}
        dataPie={lastThirtyAudiencePie}
        lastAudience={lastAudience}
        DivMinute={DivMinute}
        DivChart={DivChart}
      />
      <MediaNetWorkMessage info={showInfo} infoText={infoSpan} audience={audienceMedia.length > 0 ? audienceMedia[0] : []} />
    </div>
  );
}
export default Media;

